import { render, staticRenderFns } from "./DashboardOrderChart.vue?vue&type=template&id=6e432330&"
import script from "./DashboardOrderChart.vue?vue&type=script&lang=js&"
export * from "./DashboardOrderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports